const configApp = {
  concept: {
    paymentStatus: "PAYMENT_STATUS",
    generalQuestion: "GENERAL_QUESTION",
    privacyPolicy: "TERM_CONDITION",
    support: "SUPPORT",
    areaCode: "SUPPLIER_AREA",
    fileType: "TYPE_FILE",
  },
  type: {
    codeTypeAD: "UAD",
    codeTypeCOGNITO: "COG",
    orderDisable: "PAD",
    orderPayed: "PAY",
    orderNotPayed: "PAN",
    typeMessage: "MESSAGES",
    required: "E1SS",
    omit: "A13",
  },
  action: {
    add: "ADD",
    edit: "UPDATE",
    list: "VIEW",
    delete: "DELETE",
  },
}

export default {
  configApp,
}
